import { RouteConfig } from 'vue-router';
import Statistics from '@/views/default/Statistics.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/statistics/',
		name: 'statistics',
		component: Statistics,
	},
	{
		path: '/statistics/:type/:company_id',
		name: 'company_statistics',
		component: Statistics,
	},
];

routes.map(route => {
	route.meta = route.meta || {};
	route.meta.levelGuard = [1, 5, 6];
});

export default routes;
